import React from 'react';
import { useLocation } from 'react-router-dom';
import ShareFeedback from '../components/ShareFeedback';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const ShareFeedbackPage = () => {
  const query = useQuery();
  const serviceId = query.get('service_id');

  return (
    <div style={{ minHeight: '100vh', background: '#f4f7fb' }}>
      <ShareFeedback serviceId={serviceId} />
    </div>
  );
};

export default ShareFeedbackPage;
